import React from "react";
import moment from 'moment';

export class TournamentDetailsTv extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      tournament: this.props.tournament,
      day1: '',
      day2: '',
      day3: '',
      day4: '',
      meetingTime: ''
    }
  }
  
  
  
  componentWillReceiveProps(newProps) {
    this.setState({
      tournament: newProps.tournament,
      day1: moment.utc(new Date(newProps.tournament.tourDay1)).format('lll'),
      day2: moment.utc(new Date(newProps.tournament.tourDay2)).format('lll'),
      day3: moment.utc(new Date(newProps.tournament.tourDay3)).format('lll'),
      day4: moment.utc(new Date(newProps.tournament.tourDay4)).format('lll'),
      meetingTime: moment.utc(new Date(newProps.tournament.captMeetingTime)).format('lll')
    });
  }
  
  countProperties(obj) {
    var count = 0;

    for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
            ++count;
    }
if(count > 20) {
  return count;
}
  return
}
  
  render() {
    return (
      <div className="details-container-tv">
        {this.props.tournament.tourDay1 ? <div className="pesc_details-text-tv">{ moment.utc(new Date(this.props.tournament.tourDay1)).format('MMM Do') } - { moment.utc(new Date(this.props.tournament.tourDay2)).format('Do YYYY') }</div>: null}
        {this.props.tournament.tourDay3 ? <div className="details-text-tv">Day 3 Lines In: { moment.utc(new Date(this.props.tournament.tourDay3)).format('MMM Do') }</div>: null}
        {this.props.tournament.tourDay4 ? <div className="details-text-tv">Day 4 Lines In: { moment.utc(new Date(this.props.tournament.tourDay4)).format('MMM Do') }</div> : null}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/pescadora/comps/TournamentDetailsTv.js